/* eslint-disable react/forbid-prop-types */
import React, { Fragment } from "react";
import { connect } from "react-redux";
import {Route, Link, Routes, useParams} from 'react-router-dom';
import moment from 'moment';
import parse from 'html-react-parser';
import PropTypes from "prop-types";
import Preview from "../common/preview"
import { bindActionCreators } from "redux";
import * as eventActions from "../../redux/actions/eventActions";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Preloader from "../Preloader/Preloader";
import { Settings } from "../../utils/Settings";
import { isAdmin } from "../../utils/Authentication";


toast.configure({
  autoClose: 8000,
  draggable: false,
});

class EventDetails extends React.Component {
  componentDidMount() {
    const { actions } = this.props;
    actions.fetchEvent(this.props.match.params.id);
  }

  componentDidUpdate(prevProps) {
    if (this.props.response !== prevProps.response) {
      
    }
  }

  constructor(props) {
    super(props);
    this.state = { key: "description" };
  }

  handleChange = (event) => {
    
  };

  handleNewClick = (e, event) => {
    e.preventDefault();
  };

  handleSubmit = (event) => {
  };

  closeModal = () => {
    const { actions } = this.props;
    actions.hideModal();
  };

  label = (event) => {    
    let lb = event.title;
  
    if (lb == null || lb.length === 0) {
      if (event.details) {
        lb = event.details;
      } else {
        if (event.uploads) {
          const videos  = event.uploads.filter(u => u.path.endsWith('.mp4'));
          const pdfs  = event.uploads.filter(u => u.path.endsWith('.pdf'));  
          if (videos.length > 0) {
            lb = videos[0].name;
          } else if(pdfs.length > 0) {
            lb = pdfs[0].name;
          }
        }
      }
    }
    
    if (lb == null || lb.length === 0) {
      lb = "";
    }
    return lb;
  };
  
  formatDate = (value) => {
    if (value) {
      return moment(String(value)).format('MMMM Do YYYY, h:mm:ss a')
    }
  };

  render() {
    let {event = null, isLoading = true} = this.props;
    if (event === null) {
      event = this.props.location.state.event;
    }
    return (
      !isLoading ? <Fragment>
        <div className="blue-strip">
          <div className="row">
            <div className="col-10">
              {parse(this.label(event))}
              <div>
                <b></b>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <i className="fa fa-clock"></i> {this.formatDate(event.startDateTime)}
              </div>
            </div>
            {isAdmin() ? (
            <div className="col-2">
              <div className="edit-event">
                <Link
                    to={{
                      pathname: `/events/${event.id}/edit/`,
                      state: {
                        event: event,
                      },
                    }}
                    className="custom-btn d-inline-flex align-items-center m-2 m-sm-0"
                    >
                    <i className="fa fa-edit"></i> Edit
                </Link>
              </div>
            </div>) : <></>}
          </div>
        </div>

        <div className="event-body">
        { event.cover && event.cover.id > 0 ? (
                      <div className="event-cover"><img src={Settings.getFile(event.cover.path)} /></div>
                    ) : null}
          {event.details ? parse(event.details) : ""}
        </div>
        {event.uploads && event.uploads.length > 0 ? (
          <Preview files={event.uploads}/>
        ) : null}
        
      </Fragment> : <Preloader/>
    );
  }
}

EventDetails.propTypes = {
  actions: PropTypes.object.isRequired,
  event: PropTypes.object,
  response: PropTypes.object,
  error: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  showModal: PropTypes.bool.isRequired,
  events: PropTypes.array.isRequired,
};

function mapStateToProps(state) {
  return {
    events: state.events.events,
    error: state.events.error,
    isLoading: state.events.isLoading,
    showModal: state.events.showModal,
    event: state.events.event,
    response: state.events.response,
  };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(eventActions, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(EventDetails);
